import {Injectable} from '@angular/core';
import {AppService} from '../../../app-common/services/app/app.service';
import {ApiService} from '../../../app-common/services/server/api.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private appService: AppService,
              public httpService: ApiService) {
  }

  async sendFeedbackEmail(feedbackData: any) {
    await this.httpService.applicationApiClient.post('Feedback/SendFeedback', feedbackData);
    this.appService.showSuccessMessage('Feedback email sent successfully.');
  }

}
